module.exports = __webpack_public_path__ + "img/04e3ceb.jpg";